import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditSmall1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEditSmall1"><Path d="M10 6.75781V14H17.2422L21 10.2432V21H3V3H13.7578L10 6.75781Z" fill="currentColor"/><Path d="M23.4141 5L16.4141 12H12V7.58594L19 0.585938L23.4141 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEditSmall1;
